import { httpClient } from "ultis/axios";

const getListCallFlow = (params) => {
  return httpClient.get("/cloud-pbx/CallFlows", {
    params,
  });
};

const getCallFlowDetail = (id) => {
  return httpClient.get(`/cloud-pbx/CallFlows/${id}`);
};

const getCountListCallFlow = (params) => {
  return httpClient.get("/cloud-pbx/CallFlows/count", {
    params,
  });
};

const createCallFlow = (payload) => {
  return httpClient.post("/cloud-pbx/CallFlows", payload);
};

const editCallFlow = (id, payload) => {
  return httpClient.put(`/cloud-pbx/CallFlows/${id}`, payload);
};
const updateStatusCallFlow = (id, payload) => {
  return httpClient.put(`/cloud-pbx/CallFlows/change-status/${id}`, payload);
};

export const CallFlowApi = {
  getListCallFlow,
  getCountListCallFlow,
  createCallFlow,
  editCallFlow,
  getCallFlowDetail,
  updateStatusCallFlow,
};
